import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import '@/assets/css/element.scss'//自定义主题
import locale from "element-plus/es/locale/lang/zh-cn";
import '@/assets/css/reset.css';
const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(router).use(ElementPlus,{locale}).mount('#app')
